export { default } from './articlesSectionSlice';
